import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
export default function CarouselSection({images = []}) {
    
    return (
         <div className='carousel-container'>
             <Swiper
                    spaceBetween={50}
                    slidesPerView={4}
                    onSlideChange={() => console.log('slide change')}
                    onSwiper={(swiper) => console.log(swiper)}
                    className='carousel-main'
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={image.id} className='carousel-item'>
                                <img
                                    className="carousel-img"
                                    src={require("../../../assets/images/projects/" + image.image)}
                                    alt="First slide"
                                />
                            </SwiperSlide>
                        ))}
                </Swiper>
            </div>
    )
}
